export const RIB_MULTIPLIER = 1.2;
export const RIB_DEC_RATIO = 0.9;
